// Constants for preset attributes and CSS properties
export const DATA_PRESET_ATTRIBUTE = 'data-preset'
export const CSS_PRESET_PREFIX = '--preset'
export const COMPONENT_CLASS_PREFIX = 'w-'
export const ROOT_ELEMENT_KEY = 'root'

// DOM element IDs
export const WIX_WARMUP_DATA_ELEMENT_ID = 'wix-warmup-data'

// Performance measurement names
export const INIT_PRESETS_POLYFILL_SSR_MARK = 'initPresetsPolyfillSsr'

// Builder hierarchy loading states
export const BUILDER_HIERARCHY_LOADING_STATE = {
	IN_PROGRESS: 'IN_PROGRESS',
	DONE: 'DONE',
} as const

export type BuilderHierarchyLoadingState =
	(typeof BUILDER_HIERARCHY_LOADING_STATE)[keyof typeof BUILDER_HIERARCHY_LOADING_STATE]

export type BuilderHierarchyLoadingInfo = {
	state: BuilderHierarchyLoadingState
}
